<template>
    <div class="sidebar bg-black">
        <main-menu/>
    </div>
</template>

<script>
    import MainMenu from "../components/MainMenu";

    export default {
        name: 'Sidebar',
        components: {MainMenu},
    }
</script>

<style lang="scss" scoped>
    .sidebar{
        @apply h-screen overflow-y-scroll p-6 fixed;
        width: 250px;
        transform: translateX(-250px);
        transition: transform 0.3s ease-in;
        padding-top:70px;

        @media (min-width: 768px) {
            padding-top:25vh;
        }
    }

    .open{
        transform: translateX(0);
    }
</style>
